import { required } from "../../../../../../../shared/utils/forms/utils/validationType";
import { concentratorType } from "../../../../../../../shared_lsi_sg/concentratorData";

const buildValidations = (prefix: string, t: any) => ([
  {
    name: `${prefix}.flowRest`,
    validations: [
      {
        name: required,
        params: {
          name: t("prescription.template.flowRest")
        }
      }
    ]
  },
  {
    name: `${prefix}.flowRestHourDie`,
    validations: [
      {
        name: required,
        params: {
          name: t("prescription.template.hourDie")
        }
      }
    ]
  },
  {
    name: `${prefix}.underStressFlow`,
    validations: [
      {
        name: required,
        params: {
          name: t("prescription.template.underStressFlow")
        }
      }
    ]
  },
  {
    name: `${prefix}.underStressFlowHourDie`,
    validations: [
      {
        name: required,
        params: {
          name: t("prescription.template.hourDie")
        }
      }
    ]
  },
  {
    name: `${prefix}.nightFlow`,
    validations: [
      {
        name: required,
        params: {
          name: t("prescription.template.nightFlow")
        }
      }
    ]
  },
  {
    name: `${prefix}.nightFlowHourDie`,
    validations: [
      {
        name: required,
        params: {
          name: t("prescription.template.hourDie")
        }
      }
    ]
  }
]);

export const useValidationConcentratorPortable = (t: any, dataForm: any) => {
  const validations = [
    {
      name: "pathology",
      validations: [
        {
          name: required,
          params: {
            name: t("common.pathologies")
          }
        }
      ]
    },
    ...(dataForm?.concentratorType === concentratorType.portable ? buildValidations("portable", t) : []),
    ...(dataForm?.concentratorType === concentratorType.transportable ? [
      {
        name: "transportable.flowType",
        validations: [
          {
            name: required,
            params: {
              name: t("prescription.template.flowType.label")
            }
          }
        ]
      },
      ...buildValidations("transportable", t)
    ] : [])
  ];

  return validations;
};
